/**
 * Created by Ning Jiang on 2021-04-13.
 */

import {TweenLite} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class FullScreenSmoke extends PIXI.Sprite {

    private _smokeTween:TweenLite | null;
    private _smokePlaying:boolean;

    constructor(texture:PIXI.Texture) {
        super(texture);
        this.anchor.set(0, 0.5);
        this.scale.set(10);
        this.alpha = 0;
    }

    // the container is in the center of the screen.
    public playSmoke(container:PIXI.Container):void {
        this.clearTween();
        this._smokePlaying = true;
        this.x = -NolimitApplication.screenBounds.width * 0.5 - 100;
        this.loopSmokePanning();
        container.addChild(this);
        TweenLite.fromTo(this, 0.7, {alpha : 0}, {alpha : 1});
    }

    private loopSmokePanning():void {
        if(!this._smokePlaying) {
            return;
        }

        this.clearTween();
        this._smokeTween = TweenLite.to(this, 400, {
            x : NolimitApplication.screenBounds.width * 0.5 + 100,
            onComplete : () => {
                this.x = -NolimitApplication.screenBounds.width * 0.5 - this.width - 100;
                this.loopSmokePanning();
            }
        });
    }

    public stopSmoke():void {
        this._smokePlaying = false;
        TweenLite.to(this, 0.5, {
            alpha : 0, onComplete : () => {
                this.clearTween();
                if(this.parent) {
                    this.parent.removeChild(this);
                }
            }
        })
    }

    private clearTween():void {
        if(this._smokeTween?.isActive()) {
            this._smokeTween.pause();
            this._smokeTween.kill();
        }
        this._smokeTween = null;
    }

    public onResize() {
        if(this._smokePlaying) {
            this.clearTween();
            this.playSmoke(this.parent);
        }
    }
}